import { render, staticRenderFns } from "./Navbar.vue?vue&type=template&id=89f63d88&scoped=true&"
import script from "./navbar.ts?vue&type=script&lang=ts&"
export * from "./navbar.ts?vue&type=script&lang=ts&"
import style0 from "./Navbar.vue?vue&type=style&index=0&id=89f63d88&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89f63d88",
  null
  
)

export default component.exports